import React from 'react';

import ReadonlyItem from '@/components/input/ReadonlyItem';
import TextFieldInput, { TextFieldInputProps } from '@/components/input/TextFieldInput';

interface TextFieldItemProps extends TextFieldInputProps {
  'data-test'?: string;
  readonly?: boolean;
}

const TextFieldItem: React.FC<TextFieldItemProps> = ({ readonly, 'data-test': dataTest, ...props }) =>
  readonly ? (
    <ReadonlyItem textClassName={props.InputProps?.className} label={props.messages?.label} data-test={dataTest}>
      {props.value?.value}
    </ReadonlyItem>
  ) : (
    <TextFieldInput data-test={dataTest} {...props} />
  );

export default TextFieldItem;
